export function formatSubscriptionPrice(
  amount: number,
  currency: string,
  interval?: string,
) {
  const formattedAmount = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount / 100);

  if (!interval) {
    return { amount: formattedAmount, interval: null };
  }

  const intervalText =
    interval === "month" ? ("month" as const) : ("year" as const);

  return { amount: formattedAmount, interval: intervalText };
}

export function formatSubscriptionTimestamp(
  timestamp: number,
  format: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  },
) {
  const date = new Date(timestamp * 1000);
  return date.toLocaleDateString();
}
